import { Button, Form } from "react-bootstrap";
import { useNotificadoresStore } from "../../../store/notificadoresStore";
import { Modal, MuniSpinner2 } from "../../../components";
import useNotificadores from "../../../api/notificadores";
import { useEffect, useState } from "react";
import { useGeneralAppStore } from "../../../store/generalAppStore";
import { useActaDetalleStore } from "../../../store/actaDetalleStore";
import useActas from "../../../api/actas";

const ModalNotificadoresTable = ({ modals, handlerModal,setNotificador }) => {

  //~ ESTADOS GLOABLES
  const { loads } = useGeneralAppStore();
  const { acta } = useActaDetalleStore();
  const { notificadores } = useNotificadoresStore();

  //^ ESTADOS LOCALES
  const [hover, setHover] = useState();
  const [notificadorSelect, setNotificadorSelect] = useState();
  const [notificadoresFilter, setNotificadoresFilter] = useState();

  //TODO API
  const { getNotificadores } = useNotificadores();
  const { asignarActasANotificador } = useActas();

  useEffect(() => {
    if (!notificadores) {
      getNotificadores();
    }
    if (notificadores) {
      setNotificadoresFilter(notificadores);
    }
  }, []);
//   console.log(notificadorSelect)
//   console.log(notificadoresFilter)

  return (
    <>
      <Modal
        backdrop={true}
        show={modals.includes("notificadores_table")}
        size="md"
        onHide={() => {
          handlerModal({ modal: false, modalName: "notificadores_table" });
        }}
        title={() => "Notificadores"}
      >
        <div
          className="d-flex  align-items-center justify-content-center px-4   position-relative"
          style={{ height: "500px" }}
        >
          {loads.includes("asignar_notificador") && (
            <div
              className="position-absolute w-100 h-100 d-flex justify-content-center alig-items-center z-3 "
              style={{ backgroundColor: "rgba(255,255,255,0.7)" }}
            >
              <MuniSpinner2 />
            </div>
          )}
          {loads?.includes("notificadores") ? (
            <MuniSpinner2 />
          ) : (
            <div className="d-flex flex-column w-100 gap-3">
              <h4 className="m-0">Seleccione un notificador</h4>
              <Form.Control placeholder="Nombre"
                onChange={(e) => { setNotificadoresFilter(notificadores.filter((not) => not.nombre.toLowerCase().includes(e.target.value.toLowerCase()))) }}
              />
              <div
                className="position-relative d-flex flex-column w-100 rounded overflow-y-scroll border border-1 border-secondary-subtle mb-3"
                style={{ height: "283px" }}
              >
                {notificadoresFilter?.map((notificador) => (
                  <p
                    onClick={() => setNotificadorSelect(notificador)}
                    onMouseEnter={() => setHover(notificador)}
                    onMouseLeave={() => setHover(null)}
                    className={`m-0 p-3 ${hover?.usuarioID === notificador?.usuarioID || notificadorSelect?.usuarioID == notificador?.usuarioID ? "bg-secondary text-white" : ""}`}
                    style={{ cursor: "pointer" }}
                    key={notificador.usuarioID}
                    value={notificador.usuarioID}
                  >
                    {notificador.nombre}
                  </p>
                ))}
              </div>
              <div>
                <div className="d-flex gap-2">
                  <h5>Notificador:</h5>
                  <p className="fw-bold">
                    {notificadorSelect ? notificadorSelect.nombre : "No seleccionado"}
                  </p>
                </div>
                <Button
                  onClick={() => {
                    setNotificador(notificadorSelect)
                    handlerModal({modal:false, modalName:"notificadores_table"})
                    // asignarActasANotificador({
                    //   actas: [acta.id],
                    //   user_id_asignado: notificadorSelect.usuarioID,
                    // });
                  }}
                  variant="success"
                  disabled={notificadorSelect ? false : true}
                >
                  Confirmar
                </Button>
              </div>
            </div>
          )}
        </div>
      </Modal>
    </>
  );
};
export default ModalNotificadoresTable;
